"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportHeaderDTO = exports.ReportPayloadDTO = exports.GalReportingGroups = exports.GalArgumentsDTO = exports.GalEnvironment = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const decorators_1 = require("../decorators");
const enrich_by_1 = require("../decorators/enrich-by");
const dto_factory_1 = require("./dto-factory");
require("reflect-metadata");
const BASE_64_REGEX = /(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})/;
var GalEnvironment;
(function (GalEnvironment) {
    GalEnvironment["local"] = "local";
    GalEnvironment["dev"] = "dev";
    GalEnvironment["test"] = "test";
    GalEnvironment["staging"] = "stage";
    GalEnvironment["production"] = "prod";
})(GalEnvironment = exports.GalEnvironment || (exports.GalEnvironment = {}));
class GalArgumentsDTO {
}
exports.GalArgumentsDTO = GalArgumentsDTO;
var GalReportingGroups;
(function (GalReportingGroups) {
    GalReportingGroups["product"] = "product";
    GalReportingGroups["unrestricted"] = "unrestricted";
    GalReportingGroups["inactive"] = "inactive";
})(GalReportingGroups = exports.GalReportingGroups || (exports.GalReportingGroups = {}));
class ReportPayloadDTO {
    constructor() {
        this.user = '';
        this.fingerprint = '';
        this.localId = '';
    }
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('User Id'),
    (0, decorators_1.Warning)('Set via SDK'),
    (0, enrich_by_1.EnrichBy)([
        enrich_by_1.ENRICH_BY_META_LOOKUP.fingerprint,
        enrich_by_1.ENRICH_BY_META_LOOKUP.localId,
    ]),
    __metadata("design:type", String)
], ReportPayloadDTO.prototype, "user", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('User client fingerprint'),
    (0, decorators_1.Warning)('Set by SDK'),
    (0, enrich_by_1.EnrichBy)([enrich_by_1.ENRICH_BY_META_LOOKUP.localId]),
    __metadata("design:type", String)
], ReportPayloadDTO.prototype, "fingerprint", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Unique user identifier string'),
    (0, decorators_1.Warning)('Set by SDK'),
    (0, enrich_by_1.EnrichBy)([enrich_by_1.ENRICH_BY_META_LOOKUP.fingerprint]),
    __metadata("design:type", String)
], ReportPayloadDTO.prototype, "localId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, decorators_1.Describe)('Elapsed session time'),
    (0, decorators_1.Warning)('Set by SDK'),
    __metadata("design:type", Number)
], ReportPayloadDTO.prototype, "elapsed", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsNumber)(),
    (0, decorators_1.Describe)('Event timestamp'),
    (0, decorators_1.Warning)('Set by SDK'),
    __metadata("design:type", Number)
], ReportPayloadDTO.prototype, "timestamp", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, decorators_1.Describe)('Previous event hash'),
    (0, decorators_1.Warning)('Set by SDK'),
    __metadata("design:type", String)
], ReportPayloadDTO.prototype, "prevId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, decorators_1.Describe)('This event hash'),
    (0, decorators_1.Warning)('Set by SDK'),
    __metadata("design:type", String)
], ReportPayloadDTO.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(GalEnvironment),
    (0, decorators_1.Describe)('Application Working Environment'),
    (0, decorators_1.Warning)('Set via SDK'),
    (0, decorators_1.Example)('GalEnvironment'),
    __metadata("design:type", String)
], ReportPayloadDTO.prototype, "environment", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, decorators_1.Describe)('Gal Session ID'),
    (0, decorators_1.Warning)('Set by SDK'),
    __metadata("design:type", String)
], ReportPayloadDTO.prototype, "session", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNotEmptyObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => dto_factory_1.GalBaseDTO),
    (0, decorators_1.Describe)('DTO Object matching the request'),
    __metadata("design:type", dto_factory_1.GalBaseDTO)
], ReportPayloadDTO.prototype, "details", void 0);
exports.ReportPayloadDTO = ReportPayloadDTO;
class ReportHeaderDTO {
}
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.Matches)(new RegExp(`bearer ${BASE_64_REGEX}`, 'i')),
    __metadata("design:type", String)
], ReportHeaderDTO.prototype, "Authorization", void 0);
exports.ReportHeaderDTO = ReportHeaderDTO;
